// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

body {
  margin: 0;
  --sb-track-color: #232e33;
  --sb-thumb-color: #ffffff;
  --sb-size: 1px;
  box-sizing: border-box;
  scrollbar-gutter: stable;
  background-color: #FFFFFF;
}


:root{
  /* Primary Font Family*/
  --font-manrope-regular: 'Manrope';
  --font-family-inter: 'Inter';
  --font-size-12: 12px;
  --font-size-14: 14px;
  --font-size-16: 16px;
  --font-size-18: 18px;
  --font-size-20: 20px;
  --font-size-24: 24px;
  --font-size-30: 30px;
  --font-size-36: 36px;
  --font-size-48: 48px;
  --font-size-60: 60px;
  --font-size-72: 72px;
  --font-size-96: 96px;
  --font-size-120: 120px;
  --font-size-150: 150px;
  --font-size-180: 180px;
  --font-size-200: 200px;
  --font-weight-regular: 400;
  --letter-spacing-0: 0em;
  --letter-spacing-4: 0.004em;
  --letter-spacing-6: 0.006em;
  --letter-spacing-8: 0.008em;
  --line-height-18: 18px;
  --line-height-20: 20px;
  --line-height-22: 22px;
  --line-height-24: 24px;
  --line-height-28: 28px;
  --line-height-32: 32px;
  --line-height-36: 36px;
  --line-height-40: 40px;
  --line-height-48: 48px;
  --line-height-60: 60px;
  --line-height-72: 72px;
  --line-height-96: 96px;
  --line-height-120: 120px;
  --line-height-150: 150px;
  --line-height-180: 180px;
  --line-height-200: 200px;
  --paragraph-spacing-0: 0px;
  --paragraph-indent-0: 0px;
  --list-spacing-0: 0px;

  /* color */
  --input-hover: #000000CC;
  --action-hover: #EFF3F8;
  --input-defualt: #8A8B8F;
  --input-inline: #84A578;
  --neutralcolors-100: #FFFFFF;
  --neutralcolors-200: #F8FAFF;
  --neutralcolors-300: #F1F3F7;
  --neutralcolors-400: #E1E4ED;
  --neutralcolors-500: #B4B9C9;
  --neutralcolors-600: #6D758F;
  --neutralcolors-700: #353E5C;
  --neutralcolors-800: #19213D;
  --orange: #FF9416;
  --primarypalette-blue: #2388FF;
  --primarypalette-green: #41CC57;
  --primarypalette-red: #FF2D46;
  --primarypalette-yellow: #FFC700;
  --text-icons-light-success: #2AA63C;


  --purple: #8A38F5;
  --secondarycolors-blue100: #E3EFFF;
  --secondarycolors-blue200: #C3DDFF;
  --secondarycolors-blue300: #8DC1FF;
  --secondarycolors-blue400: #4E9FFF;
  --secondarycolors-green100: #EEF9F5;
  --secondarycolors-green200: #D3F2DD;
  --secondarycolors-green300: #ADECBB;
  --secondarycolors-green400: #81E492;
  --secondarycolors-red100: #FFECEF;
  --secondarycolors-red200: #FAC6D0;
  --secondarycolors-red300: #FB93A3;
  --secondarycolors-red400: #FE566B;
  --secondarycolors-yellow100: #FFFAE9;
  --secondarycolors-yellow200: #FAEDBF;
  --secondarycolors-yellow300: #FBE080;
  --secondarycolors-yellow400: #FED133;
  --table-hover: #F8F9FB;
  --typography-text-body-primary: #323539;
  --typography-text-body-secondary: #8A8B8F;


}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;;AAGA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;;EAErB,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,mCAAmC;;;EAGnC,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;EACtB,uCAAuC;EACvC,yCAAyC;;;AAG3C","sourcesContent":["input[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\nbody {\n  margin: 0;\n  --sb-track-color: #232e33;\n  --sb-thumb-color: #ffffff;\n  --sb-size: 1px;\n  box-sizing: border-box;\n  scrollbar-gutter: stable;\n  background-color: #FFFFFF;\n}\n\n\n:root{\n  /* Primary Font Family*/\n  --font-manrope-regular: 'Manrope';\n  --font-family-inter: 'Inter';\n  --font-size-12: 12px;\n  --font-size-14: 14px;\n  --font-size-16: 16px;\n  --font-size-18: 18px;\n  --font-size-20: 20px;\n  --font-size-24: 24px;\n  --font-size-30: 30px;\n  --font-size-36: 36px;\n  --font-size-48: 48px;\n  --font-size-60: 60px;\n  --font-size-72: 72px;\n  --font-size-96: 96px;\n  --font-size-120: 120px;\n  --font-size-150: 150px;\n  --font-size-180: 180px;\n  --font-size-200: 200px;\n  --font-weight-regular: 400;\n  --letter-spacing-0: 0em;\n  --letter-spacing-4: 0.004em;\n  --letter-spacing-6: 0.006em;\n  --letter-spacing-8: 0.008em;\n  --line-height-18: 18px;\n  --line-height-20: 20px;\n  --line-height-22: 22px;\n  --line-height-24: 24px;\n  --line-height-28: 28px;\n  --line-height-32: 32px;\n  --line-height-36: 36px;\n  --line-height-40: 40px;\n  --line-height-48: 48px;\n  --line-height-60: 60px;\n  --line-height-72: 72px;\n  --line-height-96: 96px;\n  --line-height-120: 120px;\n  --line-height-150: 150px;\n  --line-height-180: 180px;\n  --line-height-200: 200px;\n  --paragraph-spacing-0: 0px;\n  --paragraph-indent-0: 0px;\n  --list-spacing-0: 0px;\n\n  /* color */\n  --input-hover: #000000CC;\n  --action-hover: #EFF3F8;\n  --input-defualt: #8A8B8F;\n  --input-inline: #84A578;\n  --neutralcolors-100: #FFFFFF;\n  --neutralcolors-200: #F8FAFF;\n  --neutralcolors-300: #F1F3F7;\n  --neutralcolors-400: #E1E4ED;\n  --neutralcolors-500: #B4B9C9;\n  --neutralcolors-600: #6D758F;\n  --neutralcolors-700: #353E5C;\n  --neutralcolors-800: #19213D;\n  --orange: #FF9416;\n  --primarypalette-blue: #2388FF;\n  --primarypalette-green: #41CC57;\n  --primarypalette-red: #FF2D46;\n  --primarypalette-yellow: #FFC700;\n  --text-icons-light-success: #2AA63C;\n\n\n  --purple: #8A38F5;\n  --secondarycolors-blue100: #E3EFFF;\n  --secondarycolors-blue200: #C3DDFF;\n  --secondarycolors-blue300: #8DC1FF;\n  --secondarycolors-blue400: #4E9FFF;\n  --secondarycolors-green100: #EEF9F5;\n  --secondarycolors-green200: #D3F2DD;\n  --secondarycolors-green300: #ADECBB;\n  --secondarycolors-green400: #81E492;\n  --secondarycolors-red100: #FFECEF;\n  --secondarycolors-red200: #FAC6D0;\n  --secondarycolors-red300: #FB93A3;\n  --secondarycolors-red400: #FE566B;\n  --secondarycolors-yellow100: #FFFAE9;\n  --secondarycolors-yellow200: #FAEDBF;\n  --secondarycolors-yellow300: #FBE080;\n  --secondarycolors-yellow400: #FED133;\n  --table-hover: #F8F9FB;\n  --typography-text-body-primary: #323539;\n  --typography-text-body-secondary: #8A8B8F;\n\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
